<template>
    <div class="h-full">
        <div :class="config.isDetailDisplay ? 'small-list' : 'scroll-auto'">
            <Control ref="control" :config="config" @onChangeEditDataSource="onChangeEditDataSource"></Control>
        </div>
        <div v-show="config.isDetailDisplay" class="detail">
            <EditControl :dataSource="editDataSource" :config="config"></EditControl>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                config: {
                    isDetailDisplay: false,
                    dataSourceKey:null
                },
                editDataSource: {},
                initialDataSource: {}
            }
        },
        methods: {
            onChangeEditDataSource: function (dataSourceKey) {
                this.config.dataSourceKey = dataSourceKey;
            },
            syncDataSource(){
                //this.initialDataSource = this.Utils.extend({},this.editDataSource);
            },
            checkSaveStatus() {
                this.config.isDetailDisplay = false;
            }
        },
        components: {
            "EditControl": resolve => { require(['./components/editsysdicItem.vue'], resolve) },
            "Control": resolve => { require(['./components/sysdic.vue'], resolve) },
        }
    }
</script>

<style>

</style>